
import CompanyUser from "./company-user"
import Collection from "../../data-structures/collection"
import Resources from "../../resources/resources"
import {GroupedData} from "../../data-structures/group"
import FieldProto from "../../fields3/proto/field-proto"
import groupByOperator from "../../data-structures/operators/group-by"
import {SortDirection} from "../../data-structures/sort"
import resourcesSessionLoader from "../../resources/session-loader"
import exportToCsv from "../../gd-modules/export-to-csv/export-to-csv";
import sortByOperator from "../../data-structures/operators/sort-by";
import {CompanyRole} from "../../gd/const/company-role";
import {BUS_COMPANY_USERS_CHANGED} from "./@const";
import CustomEntity from "../custom-entity/custom-entity";


const debug = false
// const debug = "CompanyUsersCollection"

export default class CompanyUsersCollection extends Collection<CompanyUser> {

    constructor(models:any) {
        super(models);
    }

    static initFromResources(resources: Resources):CompanyUsersCollection {
        return new CompanyUsersCollection(resources.tasks?.models)
    }

    static async initFromJsonData(data: any[]) {
        const res = new CompanyUsersCollection(_.map(data, record=>new CompanyUser(record)))
        await res.loadMissingData()
        return res
    }

    resetFromJson(records:JSONArray):void {

        const models : CompanyUser[] = []
        _.map(records, (record:JSONObject)=>{
            models.push(new CompanyUser(record))
        })

        this.reset(models)
        // this.sort()
    }

    /** MISSING DATA [START]**/
    public async loadMissingData(options?:any):Promise<boolean> {
        return resourcesSessionLoader(this.findMissingData(options))
    }

    private async findMissingData(options?:any) {
        let allUsers        : string[] = []

        _.map(this.models, cu=>{
            allUsers.push(cu.userId)
        })

        return gd.session.findMissing({
            users: _.uniq(allUsers),
        })
    }
    /** MISSING DATA [END]**/

    // Delta
    applyDelta(method: string, data: any): void {
        debug && console.log(debug, 'applyDelta', method, data)

        const id = '{0}-{1}'.f(data.companyId, data.userId)

        switch (method) {
            case 'delete'   : this.remove(id); break
            case 'new'      : this.add(new CompanyUser(data)); break

            case 'delta'    :
                const model = this.get(id)
                if (model) model.applyDelta(data)
                break
        }
    }

    // for Glist support
    public get items():any[] {
        return this.models
    }

    /*public search():CompanyUsersCollection {
        // need implementation
        return this
    }

    public filter():CompanyUsersCollection {
        // need implementation
        return this
    }

    public sort():CompanyUsersCollection {
        // need implementation
        return this
    }*/

    public groupBy(field:FieldProto, sortDirection:SortDirection=SortDirection.ASC):GroupedData {
        const groups: GroupedData = groupByOperator(this.models, field, sortDirection) as GroupedData
        return groups
    }

    public sortBy(field:FieldProto, sortDirection:SortDirection=SortDirection.ASC) {
        this.models = sortByOperator(this.models, field, sortDirection) as CompanyUser[]
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = [], fileName: string = 'company-users'): void {
        debug && console.log(debug, 'exportToCSV', arrayOfFields, arrayOfIds, fileName)

        const list: any[] = []
        // csv header
        const header: string[] = ['Id'] // id always present and is first
        _.map(arrayOfFields, field=>{
            header.push(field.label)
        })
        list.push(header)

        // iterate through models to get export info for each required
        _(this.models)
            .filter(model=>_.isEmpty(arrayOfIds) || arrayOfIds.includes(model.id)) // filter according to arrayOfIds if any
            .map(model=>{ // add row for each resource item
                const values: any[] = [model.id] // id always present and is first

                _.map(arrayOfFields, field=>{
                    values.push(field.normalizeToCSVValue(model))
                })

                list.push(values)
            })
            .value()

        exportToCsv(list, '{0}.csv'.f(fileName))
    }


    map(func:func) {
        return this.models.map(func)
    }

    filter(func:func) {
        return this.models.filter(func)
    }

    get length():number {
        return this.models.length
    }

    exportToArrayUserId():ID[] {
        return this.map((companyUser:CompanyUser) => {
            return companyUser.user.id
        });
    }

    findByCompanyAndUser(companyId: ID, userId:ID):CompanyUser|undefined|null {

        let result = undefined;

        this.map((cu:CompanyUser) => {
            if (cu.userId === userId && cu.companyId === companyId) {
                result = cu;
                return false; // stop mapping
            }
        });

        // patch used in export time reports (at least)
        if (!result && gd.session.deletedCompanyUsers) {
            result = gd.session.deletedCompanyUsers.getByUserId(userId)
        }

        return result;
    }


    findAdmins():CompanyUser[] {
        const result : CompanyUser[] = []

        this.map((companyUser:CompanyUser)=>{
            if (companyUser.isAdmin) {
                result.push(companyUser)
            }
        })

        return result
    }

    searchCompanyUsersByName(searchString:string):CompanyUser[] {
        return _.filter(this.models, (m:CompanyUser)=>{
            if (m.companyRole === CompanyRole.CLIENT) return false
            return (m.user.name.toLowerCase().indexOf(searchString)>-1);
        })
    }

    resetAndMarkOldModelsAsDeleted(data:JSONArray) {
        const previousCollectionModels = _.clone(this.models)

        // this.reset(data)
        this.resetFromJson(data)

        // ??? where is a check for deleted ?

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                // model.isDeleted = true
                // gd.session.companyUsers.add(model)
                gd.session.deletedCompanyUsers.add(model)
            }
        })
    }


    // all BUT customers
    notClients():CompanyUser[] {
        return this.models.filter((companyUser:CompanyUser)=>{
            return (companyUser.companyId === gd.companyId && companyUser.companyRole!==gd.const.companyRole.CLIENT);
        });
    }

    // only customers...
    clients() {
        return this.models.filter((companyUser:CompanyUser)=>{
            return (companyUser.companyId === gd.companyId && companyUser.companyRole===gd.const.companyRole.CLIENT);
        });
    }

    getByUserId(userId:ID) {
        const companyUserId = gd.companyId + "-" + userId
        return this.get(companyUserId)
    }

    filterByUser(userId:ID) {

        const models = this.models.filter((m:CompanyUser)=>{
            return m.userId === userId
        })

        return new CompanyUsersCollection(models);
    }

    search(q:string):CompanyUsersCollection {
        return new CompanyUsersCollection(this.models.filter((m:CompanyUser) => {
            return (m.user.name.toLowerCase().indexOf(q)>-1);
        }));
    }

    filterByCompany(companyId:ID):CompanyUsersCollection {
        return new CompanyUsersCollection(this.models.filter((m)=>{
            return (m.companyId===companyId && m.companyRole!==gd.const.companyRole.CLIENT);
        }));
    }

    findAllByCompanyRole(companyRole:CompanyRole):CompanyUser[] {
        return this.models.filter((companyUser:CompanyUser)=>{
            return (companyUser.companyRole===companyRole);
        });
    }

    findAllByCompanyRoles(companyRoles:CompanyRole[]):CompanyUser[] {
        return this.models.filter((companyUser:CompanyUser)=>{
            return (companyRoles.includes(companyUser.companyRole))
        });
    }

    filterByCompanyAndRoles(companyId:ID,companyRoles:CompanyRole[] = [CompanyRole.GUEST, CompanyRole.USER, CompanyRole.MANAGER]) {
        return new CompanyUsersCollection(this.models.filter((m)=>m.companyId === companyId && companyRoles.includes(m.companyRole)));
    }

    filterByDepartment(departmentId:ID) {
        return new CompanyUsersCollection(
            this.models.filter((companyUser)=>{
                return (companyUser.departmentId===departmentId && companyUser.companyRole!==CompanyRole.CLIENT);
            })
        );
    }

    findAllByDepartment(departmentId:ID):CompanyUser[] {
        return this.models.filter((companyUser)=>{
            return (companyUser.departmentId===departmentId && companyUser.companyRole!==CompanyRole.CLIENT);
        });
    }

    findAllByDepartmentAndRoles(departmentId:ID, companyRoles:CompanyRole[] = [CompanyRole.GUEST, CompanyRole.USER, CompanyRole.MANAGER]):CompanyUser[] {
        return this.models.filter((m:CompanyUser)=>{
            return (m.departmentId === departmentId && companyRoles.includes(m.companyRole));
        });
    }

    filterByCompanyAndRole(companyId:ID,companyRole:CompanyRole):CompanyUsersCollection {
        return new CompanyUsersCollection(this.models.filter((m)=>{
            return (m.company.id===companyId && m.companyRole===companyRole);
        }));
    }

    resetByCompany(companyId:ID,newData:any) {

        // na samom dele in use vse eche....
        // console.error("method no is use - why r we here?");

        const oldUsersArr = this.models.filter((companyUser) => {
            return companyUser.company.id === companyId;
        });

        _.each(oldUsersArr,(model)=>{
            this.remove(model.id);
        })

        this.add(newData);
    }


    // exportToUsersCollection() {
    //     const out : UsersCollection = new UsersCollection();
    //     this.map(function(model){
    //         out.add(model.user);
    //     });
    //     return out;
    // }




    exportToOptions():Option[] {
        return this.models.map((companyUser) => {
            return {
                'value'     : companyUser.user.id,
                'label'     : companyUser.user.name,
                'icon'      : companyUser.user.icon,
                'iconObj'   : companyUser.user
            }
        })
    }

    exportToOptionsV2():Option[] {
        return this.models.map((companyUser:CompanyUser) => {
            return {
                'value': companyUser.user.id,
                'label': companyUser.user.name
            }
        });
    }

}